import script from "./newFolder.vue?vue&type=script&setup=true&lang=js"
export * from "./newFolder.vue?vue&type=script&setup=true&lang=js"

import "./newFolder.vue?vue&type=style&index=0&id=02d82efb&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02d82efb"]])

export default __exports__